import script from "./BPTAnswersField.vue?vue&type=script&lang=ts&setup=true"
export * from "./BPTAnswersField.vue?vue&type=script&lang=ts&setup=true"

import "./BPTAnswersField.vue?vue&type=style&index=0&id=b7ad0572&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7ad0572"]])

export default __exports__